import { render, staticRenderFns } from "./launch.vue?vue&type=template&id=1954673b&scoped=true"
import script from "./launch.vue?vue&type=script&lang=js"
export * from "./launch.vue?vue&type=script&lang=js"
import style0 from "./launch.vue?vue&type=style&index=0&id=1954673b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1954673b",
  null
  
)

export default component.exports